import React from 'react';
import ParkingZoneFilterList from './ParkingZoneFilterList';
import ParkingZoneSearchList from './ParkingZoneSearchList';
import ParkingZonesByDistance from './ParkingZonesByDistance';

type ParkingZoneListRendererProps = {
  activeFilterCount: number;
  searchFocus: boolean;
  debouncedSearchTerm: string;
  withLTP?: boolean;
};

const ParkingZoneListRenderer: React.FC<ParkingZoneListRendererProps> = ({
  activeFilterCount,
  searchFocus,
  debouncedSearchTerm,
  withLTP = false,
}) => {
  if (activeFilterCount > 0) {
    return (
      <ParkingZoneFilterList
        testID="search-results"
        searchTerm={debouncedSearchTerm}
      />
    );
  }

  if (searchFocus) {
    return (
      <ParkingZoneSearchList
        testID="search-results"
        searchTerm={debouncedSearchTerm}
        withLTP={withLTP}
      />
    );
  }

  return (
    <ParkingZonesByDistance testID="nearest-parking-zones" withLTP={withLTP} />
  );
};

export default ParkingZoneListRenderer;
